import React from 'react'
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import ShopProductBanner from "./Views/ShopProductBanner"
import UiRangeSlider from "../../components/form/UiRangeSlider"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent
} from "../../components/common/UiPageElements"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiFilterWr,
    UiFilterTitle,
    UiFilterSeeMore
} from "../../components/common/UiFilterComponents"
import UiFiterInput from "../../components/form/UiFilterInput"
import { UiCheckboxInput } from "../../components/form/UiInput"
import ProductsList from "./Views/ProductsList"
import ShopFilter from "./Views/ShopFilter"
import Footer from "../../components/footer/Footer"

export default function BrowseProducts(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <ShopProductBanner title="Browse Products"
                    description="Your already working hard, enjoy the benefits of various rewards you, your team and your family can enjoy." />
                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Broswe All Products"
                    currentPageLink="/ui/incentives-pre-register" />
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="4" xl="3">
                            <UiContentCol>
                                <ShopFilter />
                            </UiContentCol>
                        </UiCol>
                        <UiCol lg="8" xl="9">
                            <ProductsList />
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />
            </UiMainWrapper>

        </>
    )
}
